import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import * as $ from 'jquery'

import { dateFormat, defaultImage, findByKey } from '../../../itrust_common/components/HelperFunctions'
import TimeSlots from './TimeSlots';
import PatientRegistration from './PatientRegistration';

import { proceduresLoad } from '../../../redux/actions/public/ProcedureActions';
import { storesLoad, storeLoad, storeFirstAvailableSlotsLoad, storeStaffsLoad, storeId, setFirstAvailable, setSelectedDate } from '../../../redux/actions/public/StoreActions';
import { anonymousSettingLoad, publicAnonymousRecurringSchedulesLoad, publicAnonymousPerDaySchedulesLoad } from '../../../redux/actions/public/AnonymousSettingActions';
import { staffAvailableSlotsLoad, staffId, staffAvailableSlotsDump, staffUnAvailableSlotsLoad, staffUnAvailableDatesDump } from '../../../redux/actions/public/StaffActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions'

import { Timezones } from '../../../itrust_common/components/Timezones'
import _ from 'lodash';
import nonExistingUrlImg from '../../../assets/static/images/non_existing_url.jpg';
import nonExistingUrlImgTab from '../../../assets/static/images/non_existing_url_tab.png';

import InactiveOrgImg from '../../../assets/static/images/inactive_org.jpg';
import InactiveOrgMobileTab from '../../../assets/static/images/inactive_org_mobile.png';
import { organisationLoad, organisationValidate } from '../../../redux/actions/public/OrganisationActions';

class Appointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeTimezone: '',
      selectedStoreId: parseInt(this.props.match.params.id)
    }
    this.setSelectedDate(new Date())
  }

  async handlePublicAnonymousRecurringSchedulesLoad(filters) {
    const { dispatch, storeId } = this.props;
    const [anonymousRecurringSchedules, anonymousPerDaySchedules] = await Promise.all([
      dispatch(publicAnonymousRecurringSchedulesLoad(filters)).then(res => res.value.data.anonymous_calendar_recurring_schedules),
      storeId && dispatch(publicAnonymousPerDaySchedulesLoad(filters)).then(res => res.value.data.anonymous_calendar_per_day_schedules)
    ]);
    this.handleDisbaleRecurringDays(anonymousRecurringSchedules, anonymousPerDaySchedules);
  }

  async handleAvailableSlots(isFirstAvailable, selectedDate, staffId, storeId, isStaffChange) {
    if (storeId) {
      if (selectedDate) {
        if (isFirstAvailable)
          this.props.dispatch(storeFirstAvailableSlotsLoad(storeId, { day: selectedDate }))
        if (staffId !== '') {
          this.props.dispatch(staffAvailableSlotsLoad(staffId, { store_id: storeId, day: selectedDate }))
          if (isStaffChange) {
            let res = await this.props.dispatch(staffUnAvailableSlotsLoad(staffId, { store_id: storeId }))
            res = res.value.data.slots
            res && this.handleDisableUnavailableSlots(res)
          }
        }
      }
    }
  }

  async setStoreID(val) {
    this.props.dispatch(storeId(val))
    this.props.dispatch(storeStaffsLoad(val, { filter: { doctor: val } }))
    var store = await this.props.dispatch(storeLoad(val))
    if (store.value.data.store.default_provider_id)
      this.setStaffID(store.value.data.store.default_provider_id)
    else {
      this.props.dispatch(setFirstAvailable(true))
      this.props.dispatch(staffId(''))
    }
    this.props.dispatch(staffAvailableSlotsDump())
    this.props.dispatch(proceduresLoad({ store_id: val, rpp: 1000, sort: "position", direction: "asc" }));
    this.handleAvailableSlots(true, this.props.selectedDate, '', val, '')
    this.setStoreTimeZone(val)
    this.handlePublicAnonymousRecurringSchedulesLoad({ store_id: val, staff_id: this.props.staffId })
    this.setState({ selectedStoreId: val })
  }

  setStoreTimeZone(id) {
    var store = findByKey(this.props.stores, 'id', parseInt(id))
    var timezone = findByKey(Timezones, 'id', store.timezone)
    this.setState({ storeTimezone: timezone.name })
  }

  setStaffID(val) {
    this.props.dispatch(staffId(val))
    this.props.dispatch(staffUnAvailableDatesDump())
    this.props.dispatch(setFirstAvailable(false))
    this.handleAvailableSlots(false, this.props.selectedDate, val, this.props.storeId, true)
    this.handlePublicAnonymousRecurringSchedulesLoad({ store_id: this.props.storeId, staff_id: val })
  }

  setSelectedDate(date) {
    var formattedDate = moment(date).format("YYYY/MM/DD")
    this.props.dispatch(setSelectedDate(formattedDate))
    this.handleAvailableSlots(this.props.isFirstAvailable, formattedDate, this.props.staffId, this.props.storeId, '')
  }
  setFirstAvailableSlots(isChecked) {
    if (isChecked) {
      this.props.dispatch(staffId(''))
      this.props.dispatch(setFirstAvailable(isChecked))
      this.props.dispatch(staffAvailableSlotsDump())
      this.handleAvailableSlots(isChecked, this.props.selectedDate, '', this.props.storeId, '')
    } else {
      this.props.dispatch(setFirstAvailable(isChecked))
      this.props.dispatch(staffAvailableSlotsDump())
      this.setStaffID(this.props.store.default_provider_id || this.props.storeStaffs[0].id)
    }
  }
  onfocus(id, color) {
    $(`#${id}`).css({ "box-shadow": `0 0 0 0.125rem ${color}`, "border-color": `${color}`, "color": "#343A40" })
  }
  onblur(id, color) {
    $(`#${id}`).css({ "box-shadow": `0 0`, "border-color": `#6C757D`, "color": "#343A40" })
  }

  async handleInitialStoreSelection() {
    var store = await this.props.dispatch(storesLoad({ rpp: 100, filter: { anonymous_booking_allowed: true } }))
    if (store.value.data.stores.length > 0) {
      var defaultStore = findByKey(store.value.data.stores, 'id', this.state.selectedStoreId)
      defaultStore = defaultStore || store.value.data.stores[0]
      this.setStoreID(defaultStore.id)
      this.setStaffID(defaultStore.default_provider_id)
    }
  }

  handleDateTimePickerStyling() {
    const { button_and_link_color } = this.props.anonymousSetting
    $('.rw-cell:not(.rw-state-disabled)').css({ "background-color": `${button_and_link_color}80` })
    $('.rw-cell.rw-state-focus').css({ "background-color": `${button_and_link_color}`, "border-color": `${button_and_link_color}` })
  }

  handlePickeContainerClick(e) {
    if (this.datePickerRef.contains(e.target)) {
      setTimeout(() => {
        this.handleDateTimePickerStyling()
        this.handleDisbaleRecurringDays(this.props.anonymousRecurringSchedule, this.props.anonymousPerDaySchedules)
      }, 100);
    }
  }

  handleDisbaleRecurringDays(anonymousRecurringSchedule, anonymousPerDaySchedules) {
    var closedDays = []
    var closeDaysSpecialScheduleData = []
    var outOfOfficeDays = []
    var rows = document.getElementsByClassName("rw-calendar-body")[0].children;

    for (var k = 0; k < anonymousRecurringSchedule.length; k++) {
      if (anonymousRecurringSchedule[k].is_closed) {
        closedDays.push(k)
        for (var j = 0; j < anonymousPerDaySchedules?.length; j++) {
          if (anonymousPerDaySchedules[j].schedule_type === "special_schedule") {
            closeDaysSpecialScheduleData.push(anonymousPerDaySchedules[j])
          }
        }
      }
      if (!anonymousRecurringSchedule[k].is_closed) {
        for (var j = 0; j < anonymousPerDaySchedules?.length; j++) {
          if (anonymousPerDaySchedules[j].schedule_type === 'out_of_office') {
            outOfOfficeDays.push(anonymousPerDaySchedules[j])
          }
        }
      }
    }
    for (var i = 0; i < rows.length; i++) {
      for (var j = 0; j < closedDays.length; j++) {
        rows[i].children[closedDays[j]].classList.add('rw-state-disabled', 'rw-cell-not-allowed')
        rows[i].children[closedDays[j]].style.pointerEvents = 'none'
        rows[i].children[closedDays[j]].style.backgroundColor = '#F8F9FD'
        rows[i].children[closedDays[j]].style.borderColor = '#F8F9FD'
      }
    }

    this.handleEnablePerDaySpecialScheduleDays(closeDaysSpecialScheduleData, rows, closedDays)
    this.handleDisableOutOfOffice(outOfOfficeDays, rows, closedDays)
    this.handleDateTimePickerStyling()
  }

  handleEnablePerDaySpecialScheduleDays(closeDaysSpecialScheduleData, rows, closedDays) {
    // Enable Off Slots > if Per day special schedule exists
    const closeDaysSpecialSchedulesMap = new Map(closeDaysSpecialScheduleData.map(data => [new Date(data.start_date).toDateString(), data]));

    for (var r = 0; r < rows.length; r++) {
      for (var c = 0; c < closedDays.length; c++) {
        const slotCell = rows[r].children[closedDays[c]];
        const slotDate = new Date(slotCell.title);
        const specialScheduleData = closeDaysSpecialSchedulesMap.get(slotDate.toDateString());
        if (specialScheduleData) {
          slotCell.classList.remove('rw-state-disabled', 'rw-cell-not-allowed');
          slotCell.style.pointerEvents = 'auto';
          slotCell.style.borderColor = 'none';
        }
      }
    }
  }

  handleDisableOutOfOffice(outOfOfficeDays, rows, closedDays) {
    // Disable Open Slots > if Per day schedule is Out of office schedule exists
    let openDays = [0, 1, 2, 3, 4, 5, 6].filter(value => !closedDays.includes(value));
    const outOfOfficeDaysMap = new Map(outOfOfficeDays.map(data => [new Date(data.start_date).toDateString(), data]));

    for (var r = 0; r < rows.length; r++) {
      for (var o = 0; o < openDays.length; o++) {
        const slotCell = rows[r].children[openDays[o]];
        const slotDate = new Date(slotCell.title);
        const outOfOfficeData = outOfOfficeDaysMap.get(slotDate.toDateString());
        if (outOfOfficeData) {
          this.slotDisableStyle(slotCell)
        }
      }
    }
  }

  handleDisableUnavailableSlots(staffUnAvailableSlots) {
    const { dateFormatType } = this.props
    var rows = document.getElementsByClassName("rw-calendar-body")[0].children;
    let dateObjects = []
    if (staffUnAvailableSlots.length > 0) {
      dateObjects = staffUnAvailableSlots.map(staffUnAvailableSlot => dateFormat(staffUnAvailableSlot, dateFormatType));
      for (var r = 0; r < rows.length; r++) {
        for (let cell = 0; cell < 7; cell++) {
          const row = rows[cell];
          for (let j = 0; j < row?.children.length; j++) {
            const slotCell = row.children[j];
            if (dateObjects.includes(dateFormat(new Date(slotCell.title), dateFormatType))) {
              this.slotDisableStyle(slotCell)
            }
          }
        }
      }
    }
  }

  slotDisableStyle(slotCell) {
    slotCell.classList.add('rw-state-disabled', 'rw-cell-not-allowed');
    slotCell.style.pointerEvents = 'none';
    slotCell.style.backgroundColor = '#F8F9FD';
    slotCell.style.borderColor = '#F8F9FD';
  }

  async componentDidMount() {
    this.props.dispatch(organisationLoad())
    this.props.dispatch(organisationValidate())
    await this.props.dispatch(anonymousSettingLoad())
    this.handleInitialStoreSelection()
    this.handleDateTimePickerStyling()
  }


  handleRedirectScreen() {
    const { redirectToInactive } = this.props
    return (
      <>
        {redirectToInactive ?
          <picture>
            <source media="(max-width: 800px)" srcSet={InactiveOrgMobileTab} type="image/png" />
            <img src={InactiveOrgImg} alt='Non Existing URL Image' className='w-100 h-100' />
          </picture>
          :
          <picture>
            <source media="(max-width: 800px)" srcSet={nonExistingUrlImgTab} type="image/png" />
            <img src={nonExistingUrlImg} alt='Non Existing URL Image' className='w-100 h-100' />
          </picture>
        }
      </>
    )
  }

  render() {
    const { stores, storeStaffs, staffId, storeId, selectedDate, isFirstAvailable, activeTab, anonymousSetting, procedures, isOrgNotExist, saving, redirectToInactive, dateFormatType } = this.props
    return (
      <>
        {
          (isOrgNotExist || redirectToInactive) ? this.handleRedirectScreen() :
            <div className="anonymous-wrapper w-100 h-100" style={{ backgroundColor: `${anonymousSetting.background_color}` }}>
              {/* Header Section Now you can schedule your appointment online. It’s quick and hassle free.*/}
              <div className="pt-9 pb-7 text-center mx-auto" style={{ maxWidth: '67rem' }}>
                {
                  anonymousSetting.organisation_logo ? <img alt="logo" style={{ maxWidth: '15rem' }} src={defaultImage(anonymousSetting.organisation_logo)} /> :
                    <p className="store-logo-text py-10 mx-auto"><span className="bg-white p-4">{stores[0] && stores[0].name}</span></p>
                }
                <h5 className="pt-9">{anonymousSetting.welcome_message}</h5>
              </div>

              {/* Anonymous Calendar instructions and time slots */}
              {activeTab.anonymous === 1 && <div className={`border border-2 bg-white mx-auto mb-7 ${saving && 'disabled'}`} style={{ maxWidth: '67rem' }}>
                <div className="row mx-0 border-bottom border-bottom-2 py-4 align-items-center">
                  <div className="col-7 col-md-6">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Location</span>
                      <select
                        id="store-select"
                        className="bg-white custom-select d-inline-block ml-3 mr-7"
                        onFocus={this.onfocus.bind(this, "store-select", anonymousSetting.button_and_link_color)}
                        onBlur={this.onblur.bind(this, "store-select", anonymousSetting.button_and_link_color)}
                        onChange={(e) => this.setStoreID(e.target.value)}
                        value={this.state.selectedStoreId}
                      >
                        <option className="disabled" disabled selected>Select Store</option>
                        {stores.map(store =>
                          <option value={store.id}>{store.name}</option>
                        )}
                      </select>
                      <span>Provider</span>
                      <select
                        id="staff-select"
                        className="bg-white custom-select d-inline-block ml-3"
                        onFocus={this.onfocus.bind(this, "staff-select", anonymousSetting.button_and_link_color)}
                        onBlur={this.onblur.bind(this, "staff-select", anonymousSetting.button_and_link_color)}
                        onChange={(e) => this.setStaffID(e.target.value)} value={staffId}
                      >
                        <option value='' className="disabled" disabled selected>All</option>
                        {storeStaffs.map(staff =>
                          <option value={staff.id}>{staff.first_name} {staff.last_name}</option>
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-5 col-md-6 text-left pl-7">
                    <div className="custom-control custom-checkbox">
                      <input className="custom-control-input" type="checkbox" id="Show-first available slots" checked={isFirstAvailable} onClick={(e) => { this.setFirstAvailableSlots(e.target.checked) }} />
                      <label className="custom-control-label" htmlFor="Show-first available slots">
                        Show first available slots for selected Store.
                      </label>
                    </div>
                  </div>
                </div>
                <div ref={node => this.datePickerRef = node} className="anonymous-calendar-container row mx-0 pb-9">
                  <div className="col-7 col-md-6 anonymous-calendar">
                    <DateTimePicker
                      time={false}
                      open='date'
                      format={dateFormatType}
                      editFormat={dateFormatType}
                      placeholder={dateFormatType}
                      key={`calendar-${storeId}-${staffId}`}
                      min={moment().toDate()}
                      max={anonymousSetting.rolling_days_criteria === 'limited_days' ? moment(new Date(), "DD-MM-YYYY").add('days', anonymousSetting.number_of_days - 1) : undefined}
                      onChange={(date) => {
                        this.setSelectedDate(date)
                        setTimeout(() => {
                          this.handleDateTimePickerStyling()
                        }, 100);
                      }}
                      onClick={this.handlePickeContainerClick.bind(this)}
                    />
                  </div>
                  {(storeId && selectedDate && (isFirstAvailable || staffId !== '')) &&
                    <TimeSlots anonymousSetting={anonymousSetting} storeTimezone={this.state.storeTimezone} />
                  }
                </div>
              </div>}

              {/* Patient Short Form */}
              {activeTab.anonymous === 2 &&
                <PatientRegistration
                  storeId={storeId}
                  staffId={staffId}
                  selectedDate={selectedDate}
                  anonymousSetting={anonymousSetting}
                  procedures={procedures}
                />
              }

              {/* Successful Submission*/}
              {activeTab.anonymous === 3 && <div className="row mx-0 py-4 align-items-center">
                <div className="col-12 text-center">
                  <h6>{anonymousSetting.success_message}</h6>
                </div>
                <div className="col-12 text-center mt-6">
                  <div className="d-flex justify-content-end align-items-center justify-content-center">
                    <button className="btn btn-outline-primary ml-3" onClick={() => this.props.dispatch(tabChange({ anonymous: 1 }))}>Book Another Appointment</button>
                  </div>
                </div>
              </div>}

            </div>
        }
      </>
    );
  }
}
const mapStateToProps = state => {
  const { publicStore, publicStaff, publicAnonymousSetting, anonymousRecurringSchedule, publicProcedure, other, anonymousPerDaySchedule, publicOrganisation, organisation: { organisation } } = state
  return {
    stores: publicStore.stores,
    store: publicStore.store,
    storeStaffs: publicStore.staffs,
    storeId: publicStore.storeId,
    selectedDate: publicStore.selectedDate,
    staffId: publicStaff.staffId,
    isFirstAvailable: publicStore.isFirstAvailable,
    activeTab: other.activeTab,
    anonymousSetting: publicAnonymousSetting.anonymous_calendar_setting,
    anonymousRecurringSchedule: anonymousRecurringSchedule.anonymous_calendar_recurring_schedules,
    anonymousPerDaySchedules: anonymousPerDaySchedule.anonymous_calendar_per_day_schedules,
    procedures: publicProcedure.procedure_pricings,
    isOrgNotExist: publicOrganisation.isOrgNotExist,
    redirectToInactive: publicOrganisation.redirectToInactive,
    staffUnAvailableSlots: publicStaff.unavailable_dates,
    saving: (publicStaff.saving || publicStaff.unavailable_saving),
    dateFormatType: organisation.preferences?.date_format,
  };
};

export default connect(mapStateToProps)(Appointment);
